import { template, view, blocks, globals, anodum } from '@yola/ws-sdk';
import store from 'src/js/store';
import getAllBlocksForTarget from '../../blocks/helpers/get-all-blocks-for-target';
import adjacentPositions from '../../blocks/constants/adjacent-positions';

function sortBlocksByCategory(allBlocks, categories) {
  const order = Object.fromEntries(
    categories.map(({ name: categoryName }, index) => [categoryName, index])
  );
  return [...allBlocks].sort(
    (a, b) => (order[a.category] ?? Infinity) - (order[b.category] ?? Infinity)
  );
}

const insertAllBlocksToThePage = (featureFlags) => (targetDocument) => {
  const state = store.getState();
  const categories = blocks.selectors.getCategories(state);
  const pageContainerSelector = template.selectors.getPageContainerSelector(state);
  const pageContainerLiveElementId = view.accessors.getLiveElementId(
    view.accessors.getLiveDocument().querySelector(pageContainerSelector)
  );
  const allBlocks = getAllBlocksForTarget({
    targetElementId: pageContainerLiveElementId,
    adjacentPosition: adjacentPositions.BEFORE_END,
    featureFlags,
  });
  const pageContainer = targetDocument.querySelector(pageContainerSelector);

  pageContainer
    .querySelectorAll(`[id^='${blocks.constants.BLOCK_ID_PREFIX}']`)
    .forEach((element) => {
      element.remove();
    });

  sortBlocksByCategory(allBlocks, categories).forEach((block) => {
    const element = globals.helpers.injectGlobals(anodum.parseElementFromString(block.html));
    element.id = blocks.helpers.generateBlockId(block.id);
    element.setAttribute(blocks.attributes.VARIATION_ATTRIBUTE_NAME, block.variationId);
    pageContainer.insertAdjacentElement('beforeend', element);
  });
};

export default insertAllBlocksToThePage;
